<template>
	<div>
		<el-drawer :visible.sync="show" :with-header="false" :before-close="handleClose" :modal="true"
			:wrapperClosable="false" :append-to-body="true">
			<div class="createdrawer_box" v-loading="loading">

				<div class="write_head FlexBetween">
					<div class="title">
						新建跟进
					</div>
					<div class="close_icon" @click="handleClose">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<div class="write_content FlexWrap FlexJusBetween">
					<template v-for="(item, index) in write_list">
						<!-- 日期时间 -->
						<template v-if="item.time">
							<div class="write_items">
								<div class="write_tit">{{ item.title || "" }}</div>
								<el-date-picker v-model="item.content" class="input_w460" type="datetime"
									value-format="timestamp" placeholder="选择日期时间" default-time="12:00:00">
								</el-date-picker>
							</div>
						</template>
						<!-- 下拉选择框 -->
						<template v-else>
							<div class="write_items">
								<div class="write_tit">{{ item.title || "" }}</div>
								<newgratedropdown @outlet="fn_outlet($event, index)"
								:permit="item.permit ? item.permit : true" 
								:clearable="item.clearable ? item.clearable : false" 
								:disabled="item.disabled ? item.disabled : false" 
								:customlist="item.customlist ? item.customlist : ''" 
								:multiple="item.multiple ? item.multiple : false" 
								:seltype="item.seltype" 
								:screenid="item.screenid"
								:singleval.sync="item.selectval">
								</newgratedropdown>
							</div>
						</template>
					</template>
					<!--  -->
					<div class="write_items">
						<div class="write_tit">跟进内容</div>
						<el-input type="textarea" class="input_textarea" :rows="5" resize="none" maxlength="500"
							placeholder="请输入内容" show-word-limit v-model="followContent">
						</el-input>
						<!-- <textarea v-model="followContent" placeholder="请输入内容"></textarea> -->
					</div>
				</div>
				<!--  -->
				<div class="write_bottom FlexAlign">
					<div class="write_btn FlexRow" @click="write_save">
						保存 
					</div>
					<div class="write_btn FlexRow style2" @click="handleClose">
						取消
					</div>
				</div>
				
			</div>
		</el-drawer>
		
	</div>
</template>

<script>
	import newgratedropdown from "@/components/integrated/newgratedropdown.vue";
	import {
		getCustomerFollowUpList
	} from "network/hk_customer";
	import {
		addCustomerFollow
	} from "network/hk_operset";
	export default {
		name: "writefollow",
		components: {
			newgratedropdown,
		},
		props: {
			// 跟进联系人  {id, name}
			contact_obj: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// 关联客户
			customer_obj: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// 关联报价单
			quotation_obj: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// 关联订单
			order_obj: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// 关联合同
			contract_obj: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// 关联项目
			project_obj: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// 关联商机
			chance_obj: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// 关联回款
			return_obj: {
				type: Object,
				default: () => {
					return {};
				},
			},
			//
			show: {
				type: Boolean,
				default: false,
			},
			contact_id: {
				type: Number | String,
				default: 0,
			},
			chance_id: {
				type: Number | String,
				default: "",
			},
			contract_id: {
				type: Number | String,
				default: "",
			},
			return_id: {
				type: Number | String,
				default: "",
			},
			project_id: {
				type: Number | String,
				default: "",
			},
			order_id: {
				type: Number | String,
				default: "",
			},
			quotation_id: {
				type: Number | String,
				default: "",
			},
			
		},

		data() {
			return {
				loading: true,
				write_list: [
					{
						title: "跟进客户",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 1,
						screenid: "",
						disabled: false,
					},
					{
						title: "关联商机",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 5,
						screenid: "",
						disabled: false,
						permit: false,
						clearable: true,
						is_sale: 1,
					},
					{
						title: "跟进联系人",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 2,
						screenid: "",
						disabled: false,
						permit: false,
					},
					{
						title: "关联合同",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 7,
						screenid: "",
						disabled: false,
						permit: false,
						clearable: true,
						is_sale: 1,
					},

					{
						title: "跟进人员",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 3,
						screenid: "",
					},
					{
						title: "关联项目",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 6,
						screenid: "",
						disabled: false,
						permit: false,
						clearable: true,
						is_sale: 1,
					},

					{
						title: "协同人员",
						multiple: true,
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 3,
						screenid: "",
					},
					{
						title: "关联回款",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 8,
						screenid: "",
						disabled: false,
						permit: false,
						clearable: true,
						is_sale: 1,
					},

					{
						title: "跟进时间",
						content: Date.parse(new Date()),
						time: true,
					},
					{
						title: "关联订单",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 9,
						screenid: "",
						disabled: false,
						permit: false,
						clearable: true,
						is_sale: 1,
					},
					{
						title: "跟进方式",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						customlist: [],
					},

					{
						title: "关联报价单",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						seltype: 10,
						screenid: "",
						disabled: false,
						permit: false,
						clearable: true,
						is_sale: 1,
					},
					{
						title: "跟进类型",
						content: "",
						selectval: {
							id: "",
							name: "",
						},
						customlist: [],
					},
				],
				initial_list: [],
				followContent: "",
				typelist: [],
				waylist: [],
			};
		},
		created() {
			this.initial_list = JSON.parse(JSON.stringify(this.write_list));
			setTimeout(()=>{
				this.loading = false
			}, 2000)
		},
		watch: {
			show() {
				if (this.show) {
					if (this.initial_list.length) {
						this.write_list = JSON.parse(JSON.stringify(this.initial_list));
					}
					this.fninitial();
				} else {
					this.followContent = "";
					this.write_list = [];
				}
			},
		},
		methods: {
			fninitial() {
				
				// 获取跟进类型，方式
				this.setFollowUp(2);
				this.setFollowUp(3);
				// 跟进人员
				this.setMembers();
				// 跟进客户
				this.setCustomers();
				// 关联订单
				this.setOrders();
				// 关联报价单
				this.setQuotation();
				// 关联合同
				this.setContract();
				// 关联项目
				this.setProject();
				// 关联商机
				this.setChance();
				// 关联回款
				this.setReturn();
				// 跟进联系人
				this.seteContact();
			},
			// 跟进人员
			setMembers() {
				let index1 = this.find_data("跟进人员");
				let user_info = this.$retJSONArr(localStorage.user_info);
				if (user_info) {
					let member_id = user_info ? user_info.member_id : "";
					let member_name = user_info ? user_info.member_name : "";
					this.write_list[index1].content = member_id;
					this.write_list[index1].selectval = {
						id: member_id,
						name: member_name,
					};
				}
			},
			fn_outlet(e, index) {

				let {
					title
				} = this.write_list[index];
				if (e) {
					this.write_list[index].content = e.id;
				}
				if (title == "跟进客户") {
					for (let item of this.write_list) {
						if (item.is_sale == 1) {
							item.disabled = false;
							item.screenid = e.id;
							item.permit = true;
						}
						if (item.title == "跟进联系人") {
							item.disabled = false;
							item.screenid = e.id;
							item.permit = true;
						}
					}
				}
			},
			// 跟进客户
			setCustomers() {

				let index2 = this.find_data("跟进客户");
				if (this.customer_obj && this.customer_obj.id) {
					// 有客户信息
					for (let item of this.write_list) {
						if (item.disabled != undefined) {
							if (item.title == "跟进客户") {
								item.disabled = true;
							} else {
								item.disabled = false;
								item.screenid = this.customer_obj.id;
								item.permit = true;
							}
						}
					}

					this.write_list[index2].content = this.customer_obj.id;
					this.write_list[index2].selectval = {
						id: this.customer_obj.id,
						name: this.customer_obj.name,
					};
				} else {
					// 没有客户信息 
					for (let item of this.write_list) {
						if (item.disabled != undefined) {
							if (item.title != "跟进客户") {
								item.disabled = true;
								item.permit = false;
							}
						}
					}
				}
			},

			// 跟进联系人
			seteContact() {
				let index = this.find_data("跟进联系人");
				if (this.contact_obj && this.contact_obj.id) {
					this.write_list[index].content = this.contact_obj.id;
					this.write_list[index].selectval = this.contact_obj;
					// this.write_list[index].screenid = "";
					// this.write_list[index].disabled = true
				}
				console.log(this.contact_obj, 'contact_obj')
			},
			// 关联商机
			setChance() {
				let index = this.find_data("关联商机");
				if (this.chance_obj && this.chance_obj.id) {
					this.write_list[index].content = this.chance_obj.id;
					this.write_list[index].selectval = this.chance_obj;
					// this.write_list[index].screenid = "";
					// this.write_list[index].disabled = true
				}
			},
			// 关联合同
			setContract() {
				let index = this.find_data("关联合同");
				if (this.contract_obj && this.contract_obj.id) {
					this.write_list[index].content = this.contract_obj.id;
					this.write_list[index].selectval = this.contract_obj;
					// this.write_list[index].screenid = "";
					// this.write_list[index].disabled = true
				}
			},
			// 关联项目
			setProject() {
				let index = this.find_data("关联项目");
				if (this.project_obj && this.project_obj.id) {
					this.write_list[index].content = this.project_obj.id;
					this.write_list[index].selectval = this.project_obj;
					// this.write_list[index].screenid = "";
					// this.write_list[index].disabled = true
				}
			},

			// 关联回款
			setReturn() {
				let index = this.find_data("关联回款");
				if (this.return_obj && this.return_obj.id) {
					this.write_list[index].content = this.return_obj.id;
					this.write_list[index].selectval = this.return_obj;
					// this.write_list[index].screenid = "";
					// this.write_list[index].disabled = true
				}
			},

			// 关联订单
			setOrders() {
				let index = this.find_data("关联订单");
				if (this.order_obj && this.order_obj.id) {
					this.write_list[index].content = this.order_obj.id;
					this.write_list[index].selectval = this.order_obj;
					// this.write_list[index].screenid = "";
					// this.write_list[index].disabled = true
				}
			},
			// 关联报价单
			setQuotation() {
				let index = this.find_data("关联报价单");
				if (this.quotation_obj && this.quotation_obj.id) {
					this.write_list[index].content = this.quotation_obj.id;
					this.write_list[index].selectval = this.quotation_obj;
					// this.write_list[index].screenid = "";
					// this.write_list[index].disabled = true
				}
			},

			// 获取跟进阶段列表
			setFollowUp(type) {
				let c_index = '';
				let objArr = [];
				if (type == 2) {
					c_index = this.find_data("跟进方式");
					if (this.waylist.length) {
						objArr = JSON.parse(JSON.stringify(this.waylist));
					}
				}
				if (type == 3) {
					c_index = this.find_data("跟进类型");
					if (this.typelist.length) {
						objArr = JSON.parse(JSON.stringify(this.typelist));
					}
				}
				// 有没有旧数据可用，如果没有，发送请求
				if (objArr.length) {
					if (c_index == '') return
					this.write_list[c_index].customlist = objArr || [];
					this.write_list[c_index].content = objArr[0].id;
					this.write_list[c_index].selectval = {
						id: objArr[0].id,
						name: objArr[0].name,
					}
					
				} else {
					this.getFollowUpList(type);
				}
			},
			// 发送请求
			getFollowUpList(type) {
				getCustomerFollowUpList(type, 999).then((res) => {
					if (!this.$handlereq(res)) return
					let obj = res.result.data;
					if (obj && obj.length) {
						if (type === 2) {
							this.waylist = obj;
						} else if (type === 3) {
							this.typelist = obj;
						}
						this.setFollowUp(type);
					}
				})
			},
			// 根据标题 返回需要的索引 index
			find_data(title) {
				let res = 0;
				let index = this.write_list.findIndex((v) => v.title == title);
				if (index != -1 && this.write_list[index]) {
					res = index;
				}
				return res;
			},
			// 根据标题 返回需要的内容 content
			find_ids(title) {
				let res = ''
				let index = this.write_list.findIndex((v) => v.title == title);
				if (index != -1 && this.write_list[index]) {
					res = this.write_list[index].content;
				}
				return res;
			},
			// 保存 添加跟进
			write_save() {
				if (!this.$clickgate()) return
				let customer_id = this.find_ids("跟进客户");
				let member_id = this.find_ids("跟进人员");
				let contact_id = this.find_ids("跟进联系人");
				if (!member_id) {
					this.$alertMess("请选择跟进人员", "error");
					return
				}  
				if (!customer_id) {
					this.$alertMess("请选择跟进客户", "error");
					return
				}  
				if (!contact_id) {
					this.$alertMess("请选择跟进联系人", "error");
					return
				} 
				let follow_val = this.find_ids("跟进时间");
				let follow_time = follow_val.toString().substring(0, follow_val.toString().length - 3)
				let way = this.find_ids("跟进方式");
				let type = this.find_ids("跟进类型");
				let content = this.followContent.replace(/\n/g, '<br>')
				let data = {
					customer_id, // 是	int	客户id
					member_id, // 是	int	成员id
					follow_time, // 是	int	跟进时间
					way, // 是	int	方式id
					type, // 是	int	类型id
					content, // 否	string	内容
					contact_id, // 是	int	联系人id
				};
				let assistant_arr = this.find_ids("协同人员");
				if (assistant_arr.length) {
					data.assistant_member_id = assistant_arr.join(",") + ","; // 否	int	协同成员id
				}
				if (chance_id) {
					data.chance_id = chance_id;
				}
				
				let chance_id = this.find_ids("关联商机");
				if (chance_id) {
					data.chance_id = chance_id;
				}
				
				let contract_id = this.find_ids("关联合同");
				if (contract_id) {
					data.contract_id = contract_id;
				}
				
				let project_id = this.find_ids("关联项目");
				if (project_id) {
					data.project_id = project_id;
				}
				
				let return_id = this.find_ids("关联回款");
				if (return_id) {
					data.return_id = return_id;
				}
				
				let order_id = this.find_ids("关联订单");
				if (order_id) {
					data.order_id = order_id;
				}
				
				let quotation_id = this.find_ids("关联报价单");
				if (quotation_id) {
					data.quotation_id = quotation_id;
				}
				// 添加跟进
				addCustomerFollow(data).then((res) => {
					if (!this.$handlereq(res)) return
					this.$alertMess("添加成功");
					this.handleClose();
					this.$emit("addsuccess");
				});

			},
			// 弹出  点击遮罩和 x 关闭弹出
			handleClose(done) {
				this.$emit("update:show", false);
			},
		},
	};
</script>

<style scoped lang="scss">
	/deep/ .el-drawer.rtl {
		width: 1000px !important;
	}
	/deep/ .el-drawer {
		box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2) !important;
		border-top: 1px solid #dadee3;
	}
	.createdrawer_box {
		height: 100%;
		width: 1000px;
		min-width: 1000px;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		justify-items: stretch;
		overflow: auto;
	}
	.write_head{
		width: 100%;
		min-height: 52px;
	    border-bottom: 1px solid #dadee3;	
		padding: 0 24px ;
		position: sticky;
		top: 0;
		z-index: 100;
		background: #fff;
		.title{
		    font-size: 18px;
		    font-weight: 700;
		    color: #2e405e;	
		}
		.close_icon{
			cursor: pointer;
			color: #909399;
			:hover{
				color: red;
			}
			i{
				color:inherit;
				font-size: 20px;
			}
		}
	}
	.write_bottom {
		width: 100%;
		min-height: 65px;
		padding: 16px 24px;
		background: rgb(250,251,251);
	    border-top: 1px solid #dadee3;	
		position: sticky;
		bottom: 0;
		z-index: 100;
		.write_btn{
			min-width: 60px;
			height: 32px;
			font-size: 14px;
			background: var(--themeColors);
			color: #fff;
			border-radius: 2px;
			cursor: pointer;
			&.style2{
				margin-left: 8px;
				color: #4e5969;
				background: #fff;
				box-shadow: inset 0 0 0 1px #dadee3;
			}
		}
	}
	.write_content{
		width: 100%;
		padding: 24px;
		.write_items {
			display: flex;
			flex-direction: column;
			margin-bottom: 13px;
			.write_tit{
				color: #2e405e;
				font-size: 14px;
				font-weight: bolder;
				margin-bottom: 5px;
			}
			textarea{
				width: 952px;
				height: 350px;
				border: 1px solid #DCDFE6;
				border-radius: 2px;	
			    color: #666;
			    font-size: 14px;
				padding: 10px;
				transition: all .3s;
				&:focus{
					border-color: var(--themeColors);
				}
			}
		}
	
		/deep/ .el-textarea {
			width: 952px;
			textarea {
				width: 100%;
				height: 350px;
				min-height: 350px;
			}
		}
	}

	.input_w460 {
		width: 460px;
		height: 32px;
	}
</style>